import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { fetchConfigFromServer, classificarMensagem } from '../utils/classificarMensagem';

const AUTH = 'Basic ' + btoa('Portal:Portal1163');

const MonitoramentoContext = createContext(null);

export function MonitoramentoProvider({ children }) {
  const [pdvData, setPdvData]       = useState(null); // null = primeiro carregamento
  const [awsData, setAwsData]       = useState([]);
  const [lastUpdate, setLastUpdate] = useState(null);

  const refresh = useCallback(async () => {
    const [excRes, awsRes] = await Promise.allSettled([
      fetch(`${process.env.REACT_APP_API_823 || ''}/pdv_exception/false`, {
        headers: { Authorization: AUTH },
      }),
      fetch(`${process.env.REACT_APP_API_823 || ''}/aws`, {
        headers: { Authorization: AUTH },
      }),
    ]);

    await fetchConfigFromServer().catch(() => {});

    if (excRes.status === 'fulfilled' && excRes.value.ok) {
      const data = await excRes.value.json();
      const visiveis = [];
      const ignorados = [];
      data.forEach(r => {
        (classificarMensagem(r.mensagem).tipo === 'Ignorado' ? ignorados : visiveis).push(r);
      });

      if (ignorados.length > 0) {
        Promise.allSettled(ignorados.map(r =>
          fetch(`${process.env.REACT_APP_API_823 || ''}/pdv_exception/${r.controle}`, {
            method: 'POST',
            headers: { Authorization: AUTH },
          })
        ));
      }

      setPdvData(visiveis);
    }
    if (awsRes.status === 'fulfilled' && awsRes.value.ok) {
      setAwsData(await awsRes.value.json());
    }
    setLastUpdate(new Date());
  }, []);

  useEffect(() => {
    refresh();
    const t = setInterval(refresh, 30_000);
    return () => clearInterval(t);
  }, [refresh]);

  return (
    <MonitoramentoContext.Provider value={{ pdvData, awsData, lastUpdate, refresh }}>
      {children}
    </MonitoramentoContext.Provider>
  );
}

export function useMonitoramento() {
  return useContext(MonitoramentoContext);
}
